export default {
  sendEmail: 'Send e-mail',
  export: 'Export',
  confirm: 'Confirm',
  cancel: 'Cancel',
  close: 'Close',
  replyToMessage: 'Reply message',
  search: 'Search',
  actions: 'Actions',
  noData: 'No data available',
  noResults: 'No results found',
  loading: 'Loading...',
};
